var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "keep-alive",
        [
          _c("List", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShowList,
                expression: "isShowList"
              }
            ]
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }